module.exports = __webpack_public_path__ + "static/media/calendar-white.c8023e0d.svg";